import Login from './views/Login'
import Logout from './views/Logout'
import Users from './views/Users'
import User from './views/User'
import Groups from './views/Groups'
import Group from './views/Group'
import Modules from './views/Modules'
import Actions from './views/Actions'
import Action from './views/Action'
import ResetPassword from './views/ResetPassword'
import ResetPasswordConfirm from './views/ResetPasswordConfirm'

export default {
    routes: [
      {
        path: '/module/user/modules/:code/actions',
        name: 'UserModuleActions',
        component: Actions,
        meta: {tab: 'modules', setting_link: 'Users'}
      },
      {
        path: '/module/user/modules/:code/actions/:action_code',
        name: 'UserModuleAction',
        components: {
          right: Action,
          default: Actions
        },
        meta: {tab: 'modules', setting_link: 'Users'}
      },
      {
        path: '/module/user/modules',
        name: 'UserModules',
        component: Modules,
        meta: {tab: 'modules', setting_link: 'Users'}
      },
      {
        path: '/module/user/groups',
        name: 'UserGroups',
        component: Groups,
        meta: {tab: 'groups', setting_link: 'Users'}
      },
      {
        path: '/module/user/groups/:group_code',
        name: 'UserGroup',
        components: {right: Group, default: Groups},
        meta: {tab: 'groups', setting_link: 'Users'}
      },

      {
        path: '/module/user',
        name: 'Users',
        component: Users,
        meta: {tab: 'users', setting_link: 'Users', toolbars: ['Users']}
      },
      {
        path: '/module/user/:user_id',
        name: 'User',
        components: {right: User, default: Users},
        meta: {tab: 'users', setting_link: 'Users', toolbars: ['Users']}
      },

      {
        path: '/module/user/reset/confirm',
        name: 'ResetPasswordConfirm',
        component: ResetPasswordConfirm
      },
      {
        path: '/module/user/reset',
        name: 'ResetPassword',
        component: ResetPassword
      },
      {
        path: '/login',
        name: 'Login',
        component: Login
      },
      {
        path: '/logout',
        name: 'Logout',
        component: Logout
      }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/users/routes.js